"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = require("./components/styled");

var _arrows = _interopRequireDefault(require("./components/arrows"));

var _dots = _interopRequireDefault(require("./components/dots"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MOBILE_BREAKPOINT = 640;
var SPEED = 1.5;
var AUTOPLAY_SPEED = 5000;
var AUTOPLAY_DELAY = 3000;
var slidesToShow_DEFAULT = 1;

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getSlidesCount", function () {
      var children = _this.props.children;
      return Array.isArray(children) ? children.length : 1;
    });

    _defineProperty(_assertThisInitialized(_this), "getMaxSlideIndex", function () {
      var slidesToShow = _this.state.slidesToShow;
      return Math.max(0, _this.getSlidesCount() - slidesToShow);
    });

    _defineProperty(_assertThisInitialized(_this), "getMaxRenderIndex", function () {
      var infinite = _this.props.infinite;
      var slidesToShow = _this.state.slidesToShow;

      var childrenCount = _this.getSlidesCount(); // т.к. для бесконечного слайдера рендерятся дополнительные слайды с обеих сторон


      var actualSlidesCount = infinite ? childrenCount + 2 * slidesToShow : childrenCount;
      return Math.max(0, actualSlidesCount - slidesToShow);
    });

    _defineProperty(_assertThisInitialized(_this), "countSlidesToShow", function () {
      var _this$props = _this.props,
          responsive = _this$props.responsive,
          slidesToShowProp = _this$props.slidesToShow,
          infinite = _this$props.infinite;
      var _this$state = _this.state,
          initialSlide = _this$state.initialSlide,
          currentSlidesToShow = _this$state.slidesToShow;
      var nextSlidesToShow = slidesToShow_DEFAULT;
      var defaultResponsive = [{
        width: MOBILE_BREAKPOINT,
        slidesToShow: +slidesToShowProp
      }];
      var breakpoints = responsive ? responsive.sort(function (a, b) {
        return a.width - b.width;
      }) : defaultResponsive;
      breakpoints.forEach(function (breakpoint) {
        if (window.innerWidth > breakpoint.width) {
          nextSlidesToShow = breakpoint.slidesToShow;
        }
      });
      var isSlider = _this.getSlidesCount() > nextSlidesToShow;

      if (infinite || currentSlidesToShow !== nextSlidesToShow) {
        _this.setState({
          slidesToShow: nextSlidesToShow,
          slideScale: 100 / nextSlidesToShow,
          isSlider: isSlider
        }, function () {
          isSlider && _this.swipeTo(initialSlide, true);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "startAutoplay", function () {
      var autoplaySpeed = _this.props.autoplaySpeed;
      clearInterval(_this.autoplayLoop);
      _this.autoplayLoop = setInterval(function () {
        var initialSlide = _this.state.initialSlide;

        _this.swipeTo(initialSlide + 1, true);
      }, autoplaySpeed);
    });

    _defineProperty(_assertThisInitialized(_this), "stopAutoplay", function () {
      clearInterval(_this.autoplayLoop);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeTo", function (slide, isAuto) {
      var _this$state2 = _this.state,
          _initialSlide = _this$state2._initialSlide,
          initialSlide = _this$state2.initialSlide,
          initialRenderSlide = _this$state2.initialRenderSlide,
          slideScale = _this$state2.slideScale,
          slidesToShow = _this$state2.slidesToShow,
          isSlider = _this$state2.isSlider;
      var _this$props2 = _this.props,
          infinite = _this$props2.infinite,
          scrollByShow = _this$props2.scrollByShow;

      if (isAuto !== true && _initialSlide !== slide) {
        _this.stopAutoplay();
      }

      var maxSlideIndex = _this.getMaxSlideIndex();

      var maxRenderIndex = _this.getMaxRenderIndex();

      var nextSlide = slide;
      var nextRenderSlide;

      if (scrollByShow) {
        if (nextSlide > initialSlide) {
          if (initialSlide < maxSlideIndex && nextSlide > maxSlideIndex) {
            nextSlide = maxSlideIndex;
          }
        } else if (nextSlide < 0 && initialSlide > 0) {
          nextSlide = 0;
        }
      }

      if (infinite && isSlider) {
        // т.к. индексы смещаются на slidesToShow
        nextRenderSlide = nextSlide + slidesToShow;

        if (nextSlide < 0) {
          nextSlide = maxSlideIndex;
          nextRenderSlide = 0;
        }

        if (nextSlide > maxSlideIndex) {
          nextSlide = 0;
          nextRenderSlide = maxRenderIndex;
        }
      } else {
        nextSlide = slide < 0 ? 0 : Math.min(slide, maxSlideIndex);
        nextRenderSlide = nextSlide;
      }

      var slideIsChanged = nextSlide !== initialSlide;

      _this.transform(-nextRenderSlide * slideScale, slideIsChanged);

      if (slideIsChanged || nextRenderSlide !== initialRenderSlide) {
        _this.onSlideChange(nextSlide, nextRenderSlide);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideChange", function (slide, renderSlide) {
      _this.setState({
        initialSlide: slide,
        initialRenderSlide: renderSlide
      });

      var changeCallback = _this.props.changeCallback;
      if ('function' === typeof changeCallback) changeCallback(slide);
    });

    _defineProperty(_assertThisInitialized(_this), "transform", function (value, withTransition, grabbingCursor) {
      var sliderRef = _this.slideListRef.current;

      if (sliderRef) {
        sliderRef.style.transform = "translate".concat(_this.state.keyDirection, "(").concat(value, "%)");
        sliderRef.style.transition = withTransition ? 'transform 0.4s ease-in-out' : 'none';
        sliderRef.style.cursor = grabbingCursor ? 'grabbing' : 'grab';
      } else {
        _this.stopAutoplay();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "move", function (event, startX, startTransform) {
      var vertical = _this.props.vertical;
      var slideScale = _this.state.slideScale;
      var xCoord = event.type === 'touchmove' ? event.touches[0]["client".concat(_this.state.keyDirection)] : event["page".concat(_this.state.keyDirection)];
      var walk = xCoord - startX;
      var sliderRef = _this.slideListRef.current;
      var trackScale = sliderRef[vertical ? 'clientHeight' : 'clientWidth']; // вычисляем в процентах насколько надо сместить слайдер (начиная с 0)

      var transform = startTransform + SPEED * walk / trackScale * 100;
      var maxOffset = -_this.getMaxRenderIndex() * slideScale;
      transform = transform > 0 ? 0 : Math.max(transform, maxOffset);

      _this.transform(transform, false, true);

      if (sliderRef) {
        sliderRef.style.pointerEvents = 'none';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "moveDirection", function (e) {
      if (_this.touchStartX === null) return;
      var y = e.touches ? e.touches[0].clientY : e.clientY;
      var x = e.touches ? e.touches[0].clientX : e.clientX;

      _this.touchMoveYCoords.push(y); // в массиве остаются два элемента события touchmove - предыдущий [0] и текущий [1]


      _this.touchMoveYCoords.length === 3 && _this.touchMoveYCoords.splice(0, 1); // отслеживаю разницу между двумя точками touchmove:
      // 1. для вычисления направления свайпа по Y ("+" - свайп вверх / "-" - свайп вниз);
      // 2. для вычисления "скорости" свайпа - чем больше разница между точками, тем быстрее происходит свайп.

      var deltaMove = _this.touchMoveYCoords[0] - _this.touchMoveYCoords[1];
      _this.deltaX = _this.touchStartX - x;
      _this.deltaY = _this.touchStartY - y;
      _this.props.vertical || Math.abs(_this.deltaX) > Math.abs(_this.deltaY) ? _this.move(e, _this.startX, _this.startTransformX) : window.scrollBy(0, deltaMove);
    });

    _defineProperty(_assertThisInitialized(_this), "startDrag", function (event) {
      _this.startX = event.type === 'touchstart' ? event.touches[0]["client".concat(_this.state.keyDirection)] : event["page".concat(_this.state.keyDirection)];
      _this.startTransformX = parseInt((_this.slideListRef.current.style.transform || '0').replace("translate".concat(_this.state.keyDirection, "("), ''));
      _this.touchStartX = event.type === 'touchstart' ? event.touches[0].clientX : event.pageX;
      _this.touchStartY = event.type === 'touchstart' ? event.touches[0].clientY : event.pageY;
      var ref = _this.sliderTrackRef.current;
      ref.onmousemove = _this.moveDirection;
    });

    _defineProperty(_assertThisInitialized(_this), "endDrag", function () {
      if (_this.touchStartX === null) return;
      var ref = _this.sliderTrackRef.current;
      var infinite = _this.props.infinite;
      var _this$state3 = _this.state,
          slideScale = _this$state3.slideScale,
          slidesToShow = _this$state3.slidesToShow,
          isSlider = _this$state3.isSlider;
      var endTransform = Math.abs(parseInt((_this.slideListRef.current.style.transform || '0').replace("translate".concat(_this.state.keyDirection, "("), '')));
      var currentSlideIndex = Math.abs(parseInt(endTransform / slideScale));
      var slideOffset = endTransform - slideScale * currentSlideIndex; // если сместили слайд больше, чем на половину, то листнуть на него

      if (Math.abs(slideOffset) > slideScale / 2) {
        currentSlideIndex++;
      } // учитываем, что у бесконечнего слайдера рендерятся по slidesToShow доп. слайдов на границах


      if (infinite && isSlider) {
        currentSlideIndex -= slidesToShow;
      }

      _this.swipeTo(currentSlideIndex);

      ref.onmousemove = null;
      _this.touchStartX = null;
      _this.touchStartY = null;
      _this.startX = null;
      _this.startTransformX = null;
      _this.touchMoveYCoords.length = 0; // "обнуляю" массив Y-координат touchmove

      var sliderRef = _this.slideListRef.current;

      if (sliderRef) {
        sliderRef.style.pointerEvents = 'initial';
      }
    });

    var _initialSlide2 = props.initialSlide,
        _slidesToShow = props.slidesToShow;
    _this.state = {
      _initialSlide: _initialSlide2,
      initialSlide: Math.max(_initialSlide2, 0),
      slidesToShow: parseInt(_slidesToShow),
      slideScale: 100 / parseInt(_slidesToShow),
      isSlider: _this.getSlidesCount() > _slidesToShow,
      keyDirection: props.vertical ? 'Y' : 'X',
      keyScale: props.vertical ? 'height' : 'width'
    };
    _this.deltaX = null;
    _this.deltaY = null;
    _this.touchMoveYCoords = [];
    _this.touchStartX = null;
    _this.touchStartY = null;
    _this.startX = null;
    _this.startTransformX = null;
    _this.sliderTrackRef = /*#__PURE__*/_react["default"].createRef();
    _this.slideListRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.countSlidesToShow();

      if (window) {
        window.addEventListener('resize', this.countSlidesToShow);
      }

      var _this$props3 = this.props,
          autoplay = _this$props3.autoplay,
          autoplayDelay = _this$props3.autoplayDelay;

      if (autoplay) {
        setTimeout(function () {
          _this2.startAutoplay();
        }, autoplayDelay);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      var _this$props4 = this.props,
          initialSlideProp = _this$props4.initialSlide,
          slidesToShowProps = _this$props4.slidesToShow,
          infinite = _this$props4.infinite,
          vertical = _this$props4.vertical,
          children = _this$props4.children;
      var _this$state4 = this.state,
          initialSlide = _this$state4.initialSlide,
          initialRenderSlide = _this$state4.initialRenderSlide,
          slidesToShow = _this$state4.slidesToShow,
          isSlider = _this$state4.isSlider; // если поменялось slidesToShow - пересчитать характеристики слайдера

      if (parseInt(prevProps.slidesToShow) !== parseInt(slidesToShowProps)) {
        this.countSlidesToShow();
      } // если поменялось initialSlide - переключить на нужный слайд


      if (prevProps.initialSlide !== initialSlideProp) {
        this.swipeTo(initialSlideProp);
      } // если поменялось vertical - поменять ключи направления


      if (prevProps.vertical !== vertical) {
        this.setState({
          keyDirection: vertical ? 'Y' : 'X',
          keyScale: vertical ? 'height' : 'width'
        });
      } // если изменилось количество слайдов


      if (prevProps.children !== children) {
        var isNowSlider = this.getSlidesCount() > slidesToShow;
        this.setState({
          isSlider: isNowSlider
        }, function () {
          !isNowSlider && _this3.swipeTo(0);
        });
      } // для бесконечного слайдера после перехода через границу - переключить на нужный слайд


      var isMainSlides = initialRenderSlide >= slidesToShow && initialRenderSlide < slidesToShow + this.getSlidesCount();

      if (infinite && !isMainSlides && isSlider) {
        setTimeout(function () {
          return _this3.swipeTo(initialSlide);
        }, 400);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (window) {
        window.removeEventListener('resize', this.countSlidesToShow);
      }

      this.stopAutoplay();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props5 = this.props,
          showArrows = _this$props5.showArrows,
          Arrows = _this$props5.arrows,
          showDots = _this$props5.showDots,
          Dots = _this$props5.dots,
          infinite = _this$props5.infinite,
          align = _this$props5.align,
          children = _this$props5.children,
          visibleCardWidth = _this$props5.visibleCardWidth,
          vertical = _this$props5.vertical,
          _this$props5$overwrit = _this$props5.overwriteStyles,
          overwriteStyles = _this$props5$overwrit === void 0 ? {} : _this$props5$overwrit,
          arrowsConfig = _this$props5.arrowsConfig,
          showTransparent = _this$props5.showTransparent,
          scrollByShow = _this$props5.scrollByShow,
          hideArrow = _this$props5.hideArrow,
          rest = _objectWithoutProperties(_this$props5, ["showArrows", "arrows", "showDots", "dots", "infinite", "align", "children", "visibleCardWidth", "vertical", "overwriteStyles", "arrowsConfig", "showTransparent", "scrollByShow", "hideArrow"]);

      var _this$state5 = this.state,
          isSlider = _this$state5.isSlider,
          slidesToShow = _this$state5.slidesToShow,
          initialSlide = _this$state5.initialSlide,
          slideScale = _this$state5.slideScale;
      var childArray = Array.isArray(children) ? children : [children];
      var slidesCount = childArray.length;
      var slides = childArray.map(function (child, index) {
        var firstSlideNum = initialSlide + 1;
        var lastSlideNum = initialSlide + slidesToShow;
        var currSlideNum = index + 1;
        var isTransparent = showTransparent && (currSlideNum < firstSlideNum || currSlideNum > lastSlideNum);
        return /*#__PURE__*/_react["default"].createElement(_styled.Slide, {
          customStyles: overwriteStyles.slide,
          key: index,
          scale: slideScale,
          vertical: vertical,
          isTransparent: isTransparent
        }, child);
      });
      var controls = [];
      var dragNDropEvents = {};

      if (isSlider) {
        // добавляем drag'n'drop
        dragNDropEvents = {
          onMouseDown: this.startDrag,
          onTouchStart: this.startDrag,
          onMouseUp: this.endDrag,
          onTouchEnd: this.endDrag,
          onMouseLeave: this.endDrag,
          onTouchCancel: this.endDrag
        }; // добавляем зацикливание

        if (infinite) {
          // последние slidesToShow слайдов дублируем в начало
          for (var i = slidesCount - 1; i >= slidesCount - slidesToShow; i--) {
            slides.unshift( /*#__PURE__*/_react["default"].createElement(_styled.Slide, {
              customStyles: overwriteStyles.slide,
              key: 'before' + i,
              scale: slideScale,
              vertical: vertical,
              isTransparent: showTransparent
            }, childArray[i]));
          } // первые slidesToShow слайдов дублируем в конец


          for (var _i = 0; _i < slidesToShow; _i++) {
            slides.push( /*#__PURE__*/_react["default"].createElement(_styled.Slide, {
              customStyles: overwriteStyles.slide,
              key: 'after' + _i,
              scale: slideScale,
              vertical: vertical,
              isTransparent: showTransparent
            }, childArray[_i]));
          }
        } // добавляем контролы


        if (showArrows) {
          var hideLeftArrow = hideArrow && initialSlide === 0;
          var hideRightArrow = hideArrow && initialSlide + slidesToShow === slidesCount;
          var swipeCount = scrollByShow ? slidesToShow : 1;
          controls.push( /*#__PURE__*/_react["default"].createElement(Arrows, {
            vertical: vertical,
            key: "arrows",
            visibleCardWidth: visibleCardWidth,
            swipeLeft: function swipeLeft() {
              return _this4.swipeTo(initialSlide - swipeCount);
            },
            swipeRight: function swipeRight() {
              return _this4.swipeTo(initialSlide + swipeCount);
            },
            hideLeftArrow: hideLeftArrow,
            hideRightArrow: hideRightArrow,
            config: arrowsConfig
          }));
        }

        if (showDots) {
          controls.push( /*#__PURE__*/_react["default"].createElement(Dots, {
            key: "dots",
            vertical: vertical,
            active: initialSlide,
            count: this.getMaxSlideIndex(),
            onClick: this.swipeTo,
            slidesToShow: slidesToShow
          }));
        }
      }

      return /*#__PURE__*/_react["default"].createElement(_styled.Wrapper, rest, /*#__PURE__*/_react["default"].createElement(_styled.Track, _extends({
        customStyles: overwriteStyles.track,
        visibleCardWidth: visibleCardWidth,
        showTransparent: showTransparent,
        ref: this.sliderTrackRef
      }, dragNDropEvents, {
        onDragStart: function onDragStart(e) {
          return e.preventDefault();
        }
      }), /*#__PURE__*/_react["default"].createElement(_styled.SlideList, {
        ref: this.slideListRef,
        isSlider: isSlider,
        align: align,
        vertical: vertical,
        onTouchMove: this.moveDirection
      }, slides)), controls);
    }
  }]);

  return Carousel;
}(_react["default"].Component);

Carousel.propTypes = {
  children: _propTypes["default"].node.isRequired,
  slidesToShow: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  responsive: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    width: _propTypes["default"].number,
    slidesToShow: _propTypes["default"].number
  })),
  initialSlide: _propTypes["default"].number,
  showArrows: _propTypes["default"].bool,
  arrows: _propTypes["default"].any,
  showDots: _propTypes["default"].bool,
  dots: _propTypes["default"].any,
  align: _propTypes["default"].string,
  infinite: _propTypes["default"].bool,
  showTransparent: _propTypes["default"].bool,
  scrollByShow: _propTypes["default"].bool,
  autoplay: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool,
  autoplaySpeed: _propTypes["default"].number,
  autoplayDelay: _propTypes["default"].number,
  arrowsConfig: _propTypes["default"].shape({
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    distance: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),
  overwriteStyles: _propTypes["default"].shape({
    slide: _propTypes["default"].object,
    track: _propTypes["default"].object
  })
};
Carousel.defaultProps = {
  slidesToShow: slidesToShow_DEFAULT,
  responsive: null,
  initialSlide: 0,
  showArrows: true,
  arrows: _arrows["default"],
  showDots: true,
  dots: _dots["default"],
  align: 'left',
  infinite: false,
  showTransparent: false,
  scrollByShow: false,
  autoplay: false,
  vertical: false,
  autoplaySpeed: AUTOPLAY_SPEED,
  autoplayDelay: AUTOPLAY_DELAY,
  changeCallback: null,
  arrowsConfig: {}
};
var _default = Carousel;
exports["default"] = _default;